<template>
  <div class="bg-white rounded-xl shadow-md overflow-hidden cursor-pointer group" @click="goToDetail">
    <div class="h-48 md:h-80 overflow-hidden relative">
      <img :src="product.image" :alt="product.title" class="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105">
      <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
        <button class="w-full bg-[#76B900] hover:bg-[#5a8f00] text-white py-2 rounded-lg font-medium transition-colors duration-300 !rounded-button whitespace-nowrap cursor-pointer">
          查看详情
        </button>
      </div>
    </div>
    <div class="p-4">
      <div class="flex justify-between items-center mb-2">
        <span class="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">{{ product.category }}</span>
        <!-- <div class="flex items-center text-gray-500">
          <i class="fas fa-heart mr-1 text-red-500"></i>
          <span>{{ product.likes }}</span>
        </div> -->
      </div>
      <h3 class="text-lg font-semibold text-gray-800 mb-2">{{ product.title }}</h3>
      <!-- <div class="flex items-center mb-2">
        <i class="fas fa-user-circle text-gray-400 mr-2"></i>
        <span class="text-gray-600 text-sm">{{ product.designer }}</span>
      </div> -->
      <div class="flex justify-between items-center">
        <span class="text-[#76B900] font-semibold">¥ {{ product.price }}</span>
        <span class="text-gray-500 text-sm">已售 {{ product.sold }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToDetail() {
      // MallPage为普通商品页，CategoryList为定制分类页
      const fromRoute = this.$route.name;
      if (fromRoute === 'CategoryList') {
        this.$router.push({ name: 'ProductCustomDetail', params: { id: this.product.id } });
      } else if (fromRoute === 'MallPage') {
        this.$router.push({ name: 'ProductDetail', params: { id: this.product.id } });
      } else {
        // 兜底：优先跳普通详情
        if (this.product.id) {
          this.$router.push({ name: 'ProductDetail', params: { id: this.product.id } });
        } else {
          this.$router.push({ name: 'ProductCustomDetail', params: { id: this.product.id } });
        }
      }
    }
  },
  mounted() {
    // console.log(this.product)
  }
}
</script> 